import Vue from 'vue'
let bus = new Vue();
let showEvent = '@cutImg';
let currComponentId = "";
export default {
  /**
   * 监听显示
   * @type {Function}
   */
  onShow: (function () {
    return function (handler) {
      bus.$on(showEvent, handler)
    }
  })(),
  /**
   * 监听回调
   */
  onCallback: (function () {
    return function (componentId, handler) {
      bus.$on(componentId, handler)
    }
  })(),
  /**
   * 显示
   * @param id 占用组件id
   * @param img 图片（string，blob，file类型）
   * @param isFixedWin 截图窗口是否固定
   */
  show: function(id, img, isFixedWin) {
    currComponentId = id;
    bus.$emit(showEvent, img, isFixedWin)
  },
  /**
   * 裁剪后回调
   * @param blob 截图后图片blob
   */
  callback: function (blob) {
    bus.$emit(currComponentId, blob)
  }
};



// WEBPACK FOOTER //
// ./src/js/bus/cropperBus.js